import React from 'react';

const BootstrapCol = ({ width, style, children }) =>
{
	return (
		<div className={'col-md-' + width } style={style}>
			{ children }
		</div>
	)
}

BootstrapCol.defaultProps = {
	width: 12
}

export default BootstrapCol ;


